import * as React from "react";
import type { SVGProps } from "react";

const SvgFamily = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={24} {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="m9.674 12 .107.216a7.027 7.027 0 0 0 1.574 2.02A3.943 3.943 0 0 0 10.199 14h-4.2a4 4 0 0 0-4 3.8V20h3.606a12.028 12.028 0 0 1 6.917-5.489l.573-.173 2.9 2.9 2.9-2.9.573.173A12.028 12.028 0 0 1 26.399 20h3.6v-2a4 4 0 0 0-3.8-4h-4.2a3.993 3.993 0 0 0-1.356.236 6.993 6.993 0 0 0 1.575-2.019l.108-.217h3.673a6 6 0 0 1 6 6v4h-4.682q.127.359.231.728l.36 1.272H4.092l.36-1.272q.1-.369.231-.728H-.001v-4.225a6 6 0 0 1 6-5.775Zm9.784 4.613-3.459 3.458-3.458-3.458A10.035 10.035 0 0 0 6.832 22h18.336a10.035 10.035 0 0 0-5.71-5.386ZM22.999 0a5 5 0 1 1-2.032 9.57 5 5 0 0 1-9.936 0 5 5 0 1 1 2.937-5.14 5.014 5.014 0 0 1 4.065 0A5 5 0 0 1 22.999 0Zm-7 6a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm7-4a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm-14 0a3 3 0 1 0 3 3 3 3 0 0 0-3-3Z"
        />
    </svg>
);
export default SvgFamily;
